export enum RecurrenceEnum {
  single = 'Única',
  daily = 'Diária',
  weekly = 'Semanal',
  monthly = 'Mensal',
  quarterly = 'Trimestral',
  semiAnnual = 'Semestral',
  yearly = 'Anual',
}

export enum RecurrenceValueEnum {
  single = '0',
  daily = '1',
  weekly = '7',
  monthly = '30',
  quarterly = '90',
  semiAnnual = '180',
  yearly = '360',
}